export const UNEXPECTED_ERROR_MESSAGE = "An unexpected error occurred";
